import { createSlice } from "@reduxjs/toolkit";
import { BOOKINK_CART } from "constants";

const initialState = {
  value: 0,
};

export const Slice = createSlice({
  name: "State",
  initialState,
  reducers: {
    updatestate: (state, action) => {
      window.localStorage.setItem(`${BOOKINK_CART}`, JSON.stringify({ ...state, ...action.payload }));
      return { ...state, ...action.payload };
    },
  },
});

export const { updatestate } = Slice.actions;

export default Slice.reducer;
